import React from 'react'
import styled from '@emotion/styled'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

type Props = {
  children?: any
}

const MainContainer = ({ children }: Props) => <Container>{children}</Container>

export default MainContainer
